/* eslint-disable react/jsx-no-bind */
import React, { useState, useCallback, useEffect } from 'react';
import { Attachment, Search } from '@rsuite/icons';

import {
  Loader,
  Table,
  FlexboxGrid,
  Input,
  InputGroup,
  IconButton,
  Button,
} from 'rsuite';
import { startOfMonth, format, parseISO, lastDayOfMonth } from 'date-fns';
import { toast } from 'react-toastify';
import { GerarCSV as CSV } from '~/utils/gerarCSV'

import { Container } from '~/styles/tabela1';

import api from '~/services/api';
import { InputDataRange } from '~/components/InputDataRange';
import { TableHeaderTooltip, TablePagination } from '~/components/TablePagination1';
import { ModalPadrao } from '~/components/Modal';
import fortCurrency from '../../../utils/formatCurrency';
import PageHeader from '../../../components/PageHeader';
import Card from '../../../components/Card';

const { HeaderCell, Column, Cell } = Table;

function ClientesInadimplentes() {
  const t = new Date();
  const [pagina, setPagina] = useState(1);
  const [dataFiltro, setDataFiltro] = useState([
    startOfMonth(new Date(), { weekStartsOn: 1 }),
    lastDayOfMonth(new Date()),
  ]);
  const [filtroNome, setFiltroNome] = useState('');
  const [clientes, setClientes] = useState({
    profissionais: [],
  });
  const [modalConfirmacao, setModalConfirmacao] = useState(false);

  const [carregando, setCarregando] = useState(false);

  const [orderBy, setOrderBy] = useState('order by semana desc');
  const [buscarCSV, setBuscarCSV] = useState(false);

  const motalTitulo = 'Gerar Relatório CSV';
  const modalTexto =
    'Deseja realmente gerar o arquivo em csv dos Clientes Inadimplentes com o filtro atual?';

  const buscarClientes = useCallback(async () => {
    setCarregando(true);
    setModalConfirmacao(false)
    try {
      const resposta = await api.get(`/relatorios/clientes/inadimplentes`, {
        params: {
          pagina,
          // datas: dataFiltro,
          estabelecimento: filtroNome,
          csv: buscarCSV,
          orderBy
        },
      });

      const lista = resposta.data.lista.map((c) => ({
        // ...c,
        ...(buscarCSV === false && c),
        "Nome Estabelecimento": c.nome_fantasia,
        "Cnpj": c.cpf_cnpj,
        "Pagamento": format(parseISO(c.pagamento), 'dd/LL/yyyy'),
        "Quantidade": c.quantidade,
        "Semana": format(parseISO(c.semana), 'dd/LL/yyyy'),
        "Status": c.status,
        "Total": fortCurrency(c.valor),
      }))

      if (buscarCSV) {
        CSV({
          data: lista,
          download: true,
        });

        setCarregando(false);
        toast.success(`Foram exportados ${lista.length} registros.`);
        setBuscarCSV(false);
        return;
      }

      setClientes({ lista, quantidade: lista.length > 0 ? lista[0].full_count : 0 });
      if (clientes.quantidade === 0) setPagina(1)
    } catch (e) {
      if (buscarCSV) {
        setCarregando(false);
        toast.error('Erro ao Exportar os dados');
        setBuscarCSV(false);
        return;
      }
      toast.error(e.message);
    }
    setCarregando(false);
  }, [pagina, filtroNome, buscarCSV, clientes.quantidade, orderBy]);

  useEffect(() => {
    buscarClientes();
  }, [buscarClientes]);


  return (
    <Container>
      <PageHeader
        title="Clientes Inadimplentes"
        subtitle="Relatório de Clientes Inadimplentes"
        actions={(
          <div
            style={{
              display: 'flex',
              gap: '12px'
            }}>
            <Button
              appearance="ghost"
              startIcon={<Attachment />}
              onClick={() => {
                setModalConfirmacao(true);
              }}
            >
              Exportar CSV
            </Button>
          </div>
        )}
      />
      <Card>

        <FlexboxGrid justify="start" align="middle">
          <InputGroup style={{ width: '300px', marginRight: '15px' }}>
            <Input
              name="nome_estabelecimento"
              value={filtroNome}
              style={{ marginRight: '10px', width: '300px' }}
              placeholder="Nome do Cliente"
              onChange={setFiltroNome}
            />
            <InputGroup.Button>
              <Search />
            </InputGroup.Button>
          </InputGroup>
        </FlexboxGrid>
        <FlexboxGrid style={{ width: '100%', marginTop: '20px' }}>
          <TablePagination
            carregando={carregando}
            dados={clientes.lista}
            quantidade={clientes.quantidade || 0}
            onChangePage={setPagina}
            setOrderBy={setOrderBy}
          >
            <Column resizable width={240} sortable>
              <HeaderCell>
                <TableHeaderTooltip label="Nome Estabelecimento" tooltip="Nome Estabelecimento" />
              </HeaderCell>
              <Cell dataKey="Nome Estabelecimento" />
            </Column>

            <Column resizable width={160}>
              <HeaderCell>
                <TableHeaderTooltip label="Cnpj" tooltip="Cnpj" />
              </HeaderCell>
              <Cell dataKey="Cnpj" />
            </Column>
            <Column resizable width={120} sortable>
              <HeaderCell>
                <TableHeaderTooltip label="Pagamento" tooltip="Pagamento" />
              </HeaderCell>
              <Cell dataKey="Pagamento" />
            </Column>
            <Column resizable width={120} sortable>
              <HeaderCell>
                <TableHeaderTooltip label="Quantidade" tooltip="Quantidade" />
              </HeaderCell>
              <Cell dataKey="Quantidade" />
            </Column>
            <Column resizable width={150} sortable>
              <HeaderCell>
                <TableHeaderTooltip label="Semana" tooltip="Semana" />
              </HeaderCell>
              <Cell dataKey="Semana" />
            </Column>
            <Column resizable width={100}>
              <HeaderCell>
                <TableHeaderTooltip label="Status" tooltip="Status" />
              </HeaderCell>
              <Cell dataKey="Status" />
            </Column>
            <Column resizable width={110}>
              <HeaderCell>
                <TableHeaderTooltip label="Total" tooltip="Total" />
              </HeaderCell>
              <Cell dataKey="Total" />
            </Column>
          </TablePagination>
        </FlexboxGrid>
      </Card>
      <ModalPadrao
        openModal={modalConfirmacao}
        setOpenModal={setModalConfirmacao}
        title={motalTitulo}
        text={modalTexto}
        funcExec={() => {
          setBuscarCSV(true);
          buscarClientes();
        }}
      />

      {carregando && <Loader center size="lg" vertical />}
    </Container>
  );
}

export default ClientesInadimplentes;
